import axios from "axios";

const store = {
    state: {},

    getters: {},

    mutations: {},

    actions: {

        storeRunnerAction(Context, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/runner/store`, payload)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        updateRunnerAction(Context, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/runner/update`, payload)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        deleteRunnerAction(Context, runnerId) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/runner/delete/${runnerId}`)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        findRunnersAction() {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/runner/report`)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },


        deletePhotoRunnerAction(Context,  payload){
            return new Promise((resolve, reject) => {
                axios
                    .post(`/runner/delete-photo`, payload)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        }
    },
};

export default store;



